// extracted by mini-css-extract-plugin
export default {"folderAddContainer":"folderAdd_folderAddContainer__sw87u","folderAdd":"folderAdd_folderAdd__ddmMY"};